// extracted by mini-css-extract-plugin
export default {"root":"my-orders-view_root__zo-6z","tabs":"my-orders-view_tabs__FoNHo","nullStateIcon":"my-orders-view_nullStateIcon__zqdrp"};